var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 672.0 288.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l672.0 0l0 288.0l-672.0 0l0 -288.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l672.0 0l0 288.0l-672.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m90.614174 18.784634l490.77164 0l0 254.07874l-490.77164 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m90.614174 18.784634l490.77164 0l0 254.07874l-490.77164 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m116.11024 42.047245l439.77954 0l0 203.90552l-439.77954 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m116.11024 42.047245l439.77954 0l0 203.90552l-439.77954 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m172.13387 146.34901l0 0c0 -38.320732 73.36183 -69.385826 163.85826 -69.385826l0 0c90.49643 0 163.85828 31.065094 163.85828 69.385826l0 0c0 38.32074 -73.36185 69.38583 -163.85828 69.38583l0 0c-90.49643 0 -163.85826 -31.065094 -163.85826 -69.38583z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m172.13387 146.34901l0 0c0 -38.320732 73.36183 -69.385826 163.85826 -69.385826l0 0c90.49643 0 163.85828 31.065094 163.85828 69.385826l0 0c0 38.32074 -73.36185 69.38583 -163.85828 69.38583l0 0c-90.49643 0 -163.85826 -31.065094 -163.85826 -69.38583z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m272.00787 105.965355l128.0 0l0 76.062996l-128.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m272.00787 105.965355l128.0 0l0 76.062996l-128.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m332.75397 195.86372l0 -9.84375q-7.375 -0.9375 -12.0 -3.3125q-4.625 -2.390625 -7.984375 -7.6875q-3.359375 -5.3125 -3.90625 -12.96875l9.890625 -1.859375q1.15625 7.9375 4.046875 11.65625q4.15625 5.25 9.953125 5.84375l0 -31.328125q-6.0625 -1.15625 -12.40625 -4.703125q-4.703125 -2.625 -7.25 -7.265625q-2.546875 -4.65625 -2.546875 -10.5625q0 -10.5 7.4375 -17.015625q4.984375 -4.375 14.765625 -5.359375l0 -4.703125l5.796875 0l0 4.703125q8.59375 0.828125 13.625 5.03125q6.453125 5.359375 7.765625 14.71875l-10.171875 1.53125q-0.875 -5.796875 -3.640625 -8.890625q-2.765625 -3.09375 -7.578125 -4.078125l0 28.390625q7.4375 1.859375 9.84375 2.890625q4.59375 2.03125 7.484375 4.9375q2.90625 2.890625 4.46875 6.890625q1.5625 3.984375 1.5625 8.625q0 10.234375 -6.515625 17.078125q-6.5 6.828125 -16.84375 7.328125l0 9.953125l-5.796875 0zm0 -86.203125q-5.734375 0.875 -9.046875 4.59375q-3.3125 3.71875 -3.3125 8.8125q0 5.03125 2.8125 8.421875q2.828125 3.390625 9.546875 5.40625l0 -27.234375zm5.796875 68.03125q5.75 -0.703125 9.484375 -4.96875q3.75 -4.265625 3.75 -10.5625q0 -5.359375 -2.65625 -8.609375q-2.640625 -3.25 -10.578125 -5.828125l0 29.96875z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m269.43832 144.0l0 0c0 -35.963737 29.80304 -65.11811 66.566925 -65.11811l0 0c17.654633 0 34.586212 6.8606415 47.069916 19.072655c12.483734 12.212013 19.49701 28.775063 19.49701 46.045456l0 0c0 35.963745 -29.80304 65.1181 -66.566925 65.1181l0 0c-36.763885 0 -66.566925 -29.154358 -66.566925 -65.1181z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m269.43832 144.0l0 0c0 -35.963737 29.80304 -65.11811 66.566925 -65.11811l0 0c17.654633 0 34.586212 6.8606415 47.069916 19.072655c12.483734 12.212013 19.49701 28.775063 19.49701 46.045456l0 0c0 35.963745 -29.80304 65.1181 -66.566925 65.1181l0 0c-36.763885 0 -66.566925 -29.154358 -66.566925 -65.1181z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.73b3d6cabb435d0570b96dcafe8a0815.svg";
export { ForwardRef as ReactComponent };